import axios from "axios";

export const getAllColloborators = async (merchantId, data) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_API_AUTH + `/collaborators/merchant/${merchantId}`,
      data
    );
    return response;
  } catch (error) {
    console.error("Erreur API getAllColloborators:", error);
    throw error;
  }
};


export const addPermissionByColla = async (token, requestData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_AUTH}/collaborators/${requestData.collaboratorId}/permissions`,
      JSON.stringify(requestData.permissions),
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur API:", error.response?.data || error.message);
    throw error;
  }
};

// export const getPermissionsByCollab = async (collaboratorId) => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_API_AUTH}/collaborators/${collaboratorId}`
//     );
//     return response.data.permissions || [];
//   } catch (error) {
//     console.error("Erreur API getPermissionsByCollab:", error);
//     throw error;
//   }
// };
export const createCollaborator = async (merchantId, token, requestBody) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_AUTH}/collaborators/${merchantId}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur API:", error);

    throw error;
  }
};

export const updateCollaborator = async (id, token, data) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_AUTH}/collaborators/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur API:", error);
    throw error;
  }
};
export const deleteCollaborator = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_AUTH}/collaborators/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Erreur API (suppression collaborateur):", error);
    throw error;
  }
};

